// RB2 Core Connect

/** YouTube video IDs are always 11 characters ([A-Za-z0-9_-]). */
const YOUTUBE_ID_RE = /^[A-Za-z0-9_-]{11}$/;

function normalizeYoutubeVideoId(raw: string): string {
  const trimmed = raw.trim();
  if (trimmed.length < 11) {
    return "";
  }
  const candidate = trimmed.slice(0, 11);
  return YOUTUBE_ID_RE.test(candidate) ? candidate : "";
}

export function extractYoutubeVideoIdFromUrl(url: string): string {
  const fromQuery = url.match(/[?&]v=([^&\s<>"')]+)/i);
  if (fromQuery) {
    return normalizeYoutubeVideoId(fromQuery[1]);
  }
  const fromEmbedOrV = url.match(/\/(?:embed|v)\/([^/?&\s<>"')]+)/i);
  if (fromEmbedOrV) {
    return normalizeYoutubeVideoId(fromEmbedOrV[1]);
  }
  const fromShorts = url.match(/\/shorts\/([^/?&\s<>"')]+)/i);
  if (fromShorts) {
    return normalizeYoutubeVideoId(fromShorts[1]);
  }
  const fromShort = url.match(/youtu\.be\/([^/?&\s<>"')]+)/i);
  if (fromShort) {
    return normalizeYoutubeVideoId(fromShort[1]);
  }
  return "";
}

/** Sizes: mqdefault 320×180, hqdefault 480×360, maxresdefault 1280×720 (not every video has it). */
export type YoutubeThumbnailQuality =
  | "mqdefault"
  | "hqdefault"
  | "maxresdefault";

export function youtubeThumbnailUrl(
  videoId: string,
  quality: YoutubeThumbnailQuality
): string {
  return `https://i.ytimg.com/vi/${videoId}/${quality}.jpg`;
}

export type ProductGalleryVideo = { name: string; url: string };

/**
 * Gallery list built from the API `videos` (YouTube links + direct file URLs like .mp4).
 */
export function buildProductGalleryVideos(
  apiVideos: Array<{ name?: string | null; url?: string | null }> | undefined | null
): ProductGalleryVideo[] {
  const out: ProductGalleryVideo[] = [];

  for (const v of apiVideos ?? []) {
    const url = String(v?.url ?? "").trim();
    if (!url) {
      continue;
    }
    out.push({
      name: String(v?.name ?? "").trim(),
      url,
    });
  }

  return out;
}
